import useJwt from "@src/auth/jwt/useJwt"
import axios from "axios"

const config = useJwt.jwtConfig

export const handleXatlovActivate = (val) => (dispatch) => dispatch({ type: "XATLOV_ACTIVATE", val })

export const getAddressTurar = (val) => (dispatch) => dispatch({ type: "XATLOV_ADDRESS", val })

export const handleXatlovSetPos = (val) => (dispatch) => {
  dispatch({ type: "XATLOV_SET_POSITION", val })
}

export const handleXatlovSelectedBusiness = (val) => (dispatch) => dispatch({ type: "SELECTED_XATLOV_BUSINESS", val })

export const handleXatlovInactive = () => (dispatch) => dispatch({ type: "XATLOV_INACTIVATE" })

export const handleTurarObjects = (lat, long, turarlar) => {
  return async (dispatch) => {
    if (lat && long) {
      dispatch(getAddressTurar(null))
      const sentData = { lat, long }
      const { data } = await axios.post(`${config.url}/foreign/xatlov/turar`, sentData)
      return dispatch({ type: "INSERT_XATLOV_TURAR", val: data.data })
    } else {
      return dispatch({ type: "INSERT_XATLOV_TURAR", val: turarlar })
    }
  }
}

export const handleNoturarObjects = (lat, long, noturarlar) => {
  return async (dispatch) => {
    if (lat && long) {
      const sentData = { lat, long }
      const { data } = await axios.post(`${config.url}/foreign/xatlov/noturar`, sentData)
      return dispatch({ type: "INSERT_XATLOV_NOTURAR", val: data.data })
    } else {
      return dispatch({ type: "INSERT_XATLOV_NOTURAR", val: noturarlar })
    }
  }
}

export const handleWhatIsHereObjects = (latlng, data, zoom) => {
  return async (dispatch) => {
    if (latlng) {
      const data = await axios.get(`${config.url}/foreign/xatlov/what-is-here?lat=${latlng[0]}&lon=${latlng[1]}&zoom=${zoom}`)
      return dispatch({ type: "INSERT_XATLOV_WHAT_IS_HERE", val: data.data })
    } else {
      return dispatch({ type: "INSERT_XATLOV_WHAT_IS_HERE", val: data })
    }
  }
}

export const handleLoading = (val) => (dispatch) => dispatch({ type: "XATLOV_LOADING", val })
